// Messages for portal/Developers (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.developers.head': 'Developers — Portal',
  'portal.developers.title': 'Developers / API',
  'portal.developers.desc': 'Manage your API keys & rate limits',
  'portal.developers.view_reference': 'View full API reference',
  'portal.developers.new_key_intro': 'New key',
  'portal.developers.new_key_warn': "— copy it now, it won't be shown again:",
  'portal.developers.copy': 'Copy',
  'portal.developers.getting_started': 'Getting started',
  'portal.developers.base_url': 'Base URL',
  'portal.developers.authenticate_with': 'Authenticate with',
  'portal.developers.scoped_prefix': 'Every request is scoped to',
  'portal.developers.scoped_company': 'your company only',
  'portal.developers.scoped_suffix': '— read plus a small set of limited writes.',
  'portal.developers.docs_notice':
    "The API gives read-only access to your own company's data — shipments, quotes, invoices and shared documents.",
  'portal.developers.access_notice':
    'API access is {access} for your company. Contact your Geo4Logistics representative to enable it.',
  'portal.developers.keys.title': 'API keys',
  'portal.developers.keys.sub': 'Shown once on creation · hashed at rest · scoped to your company',
  'portal.developers.keys.create': 'Create API key',
  'portal.developers.keys.empty': 'No API keys yet.',
  'portal.developers.keys.revoked': 'revoked',
  'portal.developers.keys.no_scopes': 'no scopes',
  'portal.developers.keys.rotate': 'Rotate',
  'portal.developers.keys.revoke': 'Revoke',
  'portal.developers.keys.confirm_revoke': 'Revoke this API key?',
  'portal.developers.keys.recent_requests': 'Recent requests ({count})',
  'portal.developers.keys.view_all': 'View all requests',
  'portal.developers.detail.head': '{name} — API key',
  'portal.developers.detail.back': 'Back to Developers',
  'portal.developers.detail.requests': 'Requests ({total})',
  'portal.developers.detail.empty': 'No requests yet.',
  'portal.developers.detail.showing': 'Showing {first}–{last} of {total}',
  'portal.developers.detail.page': 'Page {page} of {pages}',
  'portal.developers.detail.prev': 'Previous',
  'portal.developers.detail.next': 'Next',
  'portal.developers.webhooks.title': 'Webhooks',
  'portal.developers.webhooks.sub':
    'Subscribe your systems to events on your own shipments, quotes, and invoices.',
  'portal.developers.webhooks.add': 'Add endpoint',
  'portal.developers.webhooks.empty': 'No webhook endpoints yet.',
  'portal.developers.webhooks.edit': 'Edit',
  'portal.developers.webhooks.remove': 'Remove',
  'portal.developers.webhooks.confirm_remove': 'Remove this webhook endpoint?',
  'portal.developers.rate.title': 'Rate limits',
  'portal.developers.rate.sub': '429 + Retry-After + X-RateLimit-* headers on every response',
  'portal.developers.rate.limit': '{label} — limit {limit} {unit}',
  'portal.developers.rate.used': '{used} used',
  'portal.developers.endpoints.title': 'Endpoints',
  'portal.developers.endpoints.sub':
    'v1 customer API — read + limited writes · click any endpoint for a sample',
  'portal.developers.endpoints.request': 'Request',
  'portal.developers.endpoints.response': 'Response · {status}',
  // Endpoint descriptions
  'portal.developers.ep.list_shipments': "List your company's shipments",
  'portal.developers.ep.get_shipment': 'Retrieve a single shipment',
  'portal.developers.ep.tracking': 'Tracking timeline for a shipment',
  'portal.developers.ep.documents': 'Shared documents (signed URLs)',
  'portal.developers.ep.list_quotes': 'List your quotes',
  'portal.developers.ep.list_invoices': 'List your invoices',
  'portal.developers.ep.post_message': 'Post a message to a shipment',
}

export const zhTW = {
  'portal.developers.head': '開發者 — 客戶入口',
  'portal.developers.title': '開發者 / API',
  'portal.developers.desc': '管理您的 API 金鑰與速率限制',
  'portal.developers.view_reference': '查看完整 API 參考文件',
  'portal.developers.new_key_intro': '新金鑰',
  'portal.developers.new_key_warn': '— 請立即複製，之後將不再顯示：',
  'portal.developers.copy': '複製',
  'portal.developers.getting_started': '開始使用',
  'portal.developers.base_url': '基礎網址',
  'portal.developers.authenticate_with': '驗證方式',
  'portal.developers.scoped_prefix': '每個請求僅限於',
  'portal.developers.scoped_company': '貴公司',
  'portal.developers.scoped_suffix': '— 讀取加上一小組受限的寫入。',
  'portal.developers.docs_notice': 'API 提供貴公司資料的唯讀存取 — 貨件、報價、發票與共享文件。',
  'portal.developers.access_notice':
    '貴公司的 API 存取為 {access}。請聯絡您的 Geo4Logistics 代表以啟用。',
  'portal.developers.keys.title': 'API 金鑰',
  'portal.developers.keys.sub': '建立時僅顯示一次 · 靜態加密儲存 · 僅限貴公司',
  'portal.developers.keys.create': '建立 API 金鑰',
  'portal.developers.keys.empty': '尚無 API 金鑰。',
  'portal.developers.keys.revoked': '已撤銷',
  'portal.developers.keys.no_scopes': '無範圍',
  'portal.developers.keys.rotate': '輪替',
  'portal.developers.keys.revoke': '撤銷',
  'portal.developers.keys.confirm_revoke': '要撤銷此 API 金鑰嗎？',
  'portal.developers.keys.recent_requests': '近期請求（{count}）',
  'portal.developers.keys.view_all': '查看所有請求',
  'portal.developers.detail.head': '{name} — API 金鑰',
  'portal.developers.detail.back': '返回開發者',
  'portal.developers.detail.requests': '請求（{total}）',
  'portal.developers.detail.empty': '尚無請求。',
  'portal.developers.detail.showing': '顯示第 {first}–{last} 筆，共 {total} 筆',
  'portal.developers.detail.page': '第 {page} 頁，共 {pages} 頁',
  'portal.developers.detail.prev': '上一頁',
  'portal.developers.detail.next': '下一頁',
  'portal.developers.webhooks.title': 'Webhook',
  'portal.developers.webhooks.sub': '讓您的系統訂閱您自身貨件、報價與發票的事件。',
  'portal.developers.webhooks.add': '新增端點',
  'portal.developers.webhooks.empty': '尚無 Webhook 端點。',
  'portal.developers.webhooks.edit': '編輯',
  'portal.developers.webhooks.remove': '移除',
  'portal.developers.webhooks.confirm_remove': '要移除此 Webhook 端點嗎？',
  'portal.developers.rate.title': '速率限制',
  'portal.developers.rate.sub': '每個回應皆含 429 + Retry-After + X-RateLimit-* 標頭',
  'portal.developers.rate.limit': '{label} — 上限 {limit} {unit}',
  'portal.developers.rate.used': '已使用 {used}',
  'portal.developers.endpoints.title': '端點',
  'portal.developers.endpoints.sub': 'v1 客戶 API — 讀取 + 受限寫入 · 點擊任一端點查看範例',
  'portal.developers.endpoints.request': '請求',
  'portal.developers.endpoints.response': '回應 · {status}',
  'portal.developers.ep.list_shipments': '列出貴公司的貨件',
  'portal.developers.ep.get_shipment': '取得單筆貨件',
  'portal.developers.ep.tracking': '貨件的追蹤時間軸',
  'portal.developers.ep.documents': '共享文件（簽署網址）',
  'portal.developers.ep.list_quotes': '列出您的報價',
  'portal.developers.ep.list_invoices': '列出您的發票',
  'portal.developers.ep.post_message': '向貨件張貼訊息',
}
